import { Description } from '@casavo/base-ui'
import cn from 'classnames'
import React from 'react'

import { selectableButton } from './styles.css'

type Props = {
  className?: string
  dataTestId?: string
  disabled?: boolean
  onSelect: (v: Date | string) => void
  selected: boolean
  value: Date | string
}

export const SelectableButton: React.FC<Props> = ({
  children,
  className,
  dataTestId,
  disabled,
  onSelect,
  selected,
  value,
}) => {
  const getClass = (): string => {
    if (selected) return selectableButton.selected
    if (disabled) return selectableButton.disabled
    return selectableButton.default
  }

  return (
    <div
      aria-checked={selected}
      className={cn(getClass(), className)}
      data-testid={dataTestId}
      role="radio"
      tabIndex={0}
      onClick={() => {
        onSelect(value)
      }}
    >
      <Description alignment="center">{children}</Description>
    </div>
  )
}
